import { render, staticRenderFns } from "./IssuesSidebar.vue?vue&type=template&id=437f1074&scoped=true&"
import script from "./IssuesSidebar.vue?vue&type=script&lang=js&"
export * from "./IssuesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./IssuesSidebar.vue?vue&type=style&index=0&id=437f1074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f1074",
  null
  
)

export default component.exports